// extracted by mini-css-extract-plugin
export default {"CustomIcon":"RoomLobby__CustomIcon__k8ZZP","FacilitatorsList":"RoomLobby__FacilitatorsList__QeUa1"};